module.exports = __webpack_public_path__ + "static/logo31-7d400505a3f4d74cffb3749b963a6717.png";